const ChummeryCard = (props) => {
    return(
        <h1>ChummeryCard {props.name}</h1>
    )
}

export default ChummeryCard